/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Assign_Pick_OrderInputs */

const vi_reconcile_assign_pick_order = /** @type {(inputs: Reconcile_Assign_Pick_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn đơn hàng cần gán`)
};

/**

* @param {Reconcile_Assign_Pick_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_assign_pick_order = /** @type {((inputs?: Reconcile_Assign_Pick_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Assign_Pick_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_assign_pick_order(inputs)
});